/**
 * @copyright Native Instruments GmbH
 * @author Konrad Gmurek, Björn Schmitt
 */

var finderConfig = {
    mediaUrl: '/uploads/media/',
    imgCdnPath: Util.getCdnDomain('img') + '/',
    searchUrl: '/typo3conf/ext/elasticsearch/proxy.php',
    upgradeOfferedUrl: '/?eID=extbase&extensionName=NiAccount&pluginName=niaccount&controllerName=Api&actionName=upgradesShown',
    defaultSort: 'priority',
    defaultSortReverse: false,
    track_id_counter: 0,
    lazyLoadingSelector: '.finder-products-container *[data-src-ll].lazy'
};

var finderApp = angular.module("finder", ['ngRoute']);

var welcomeApp = angular.module('welcome', ['finder']);




if (!Util.isLessThanIE10()) {
    finderApp.config(function ($routeProvider, $locationProvider) {
        $locationProvider.html5Mode(true);
    });
}

finderApp.value('finderBasePath', '/typo3conf/ext/ni_assets/Resources/Public/Js/finder/');

// rendered event
finderApp.directive('onFinishRender', function ($timeout) {
    return {
        restrict: 'A',
        priority: 999,
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                $timeout(function () {
                    scope.$emit(attr.onFinishRender);
                }, 0);
            }
        }
    };
});

/**
 * Navigation
 */
finderApp.controller('navigation', ['$scope', '$rootScope', '$location', '$sce', 'finderGetPath', function ($scope, $rootScope, $location, $sce, finderGetPath) {

    $scope.categoryCaption = '';
    $scope.categoryDescription = '';
    $scope.categoryTheme = '';
    $scope.headlineColor = '';
    $scope.categoryBannerVisible = 0;
    

    var categories = {};
    var currentCategoryId;

    jQuery('.finder-categories a').each(function (i, e) {
        var node = jQuery(e);
        var id = node.data('category');
        if (id) {
            categories[node.attr('href')] = id;
        }
    });

    // displays
    function refreshCategoryInfo($scope) {

        var cc = jQuery('.finder-categories li.active').eq(1),
            caption = cc.data('caption'),
            description = cc.data('description'),
            background = cc.data('background'),
            theme = cc.data('theme'),
            headlineColor = cc.data('headline-color'),
            oldTheme = $scope.categoryTheme,
            bannerVisible = cc.data('banner-visible');

        $scope.categoryCaption = caption ? caption : '';
        $scope.categoryDescription = $sce.trustAsHtml(description ? description : '');
        $scope.categoryTheme = theme;
        $scope.headlineColor = {color:headlineColor};
        $scope.categoryBannerVisible = bannerVisible ? bannerVisible : 0;
        $scope.categoryBackground = false;

        if (bannerVisible) {
            if (background) {
                $scope.categoryBackground = background;
            }
        }

        $scope.$emit('categoryInfoRefreshed');
    }

    // handles highlighting active category
    function categoryChangeHandler($scope, categoryId) {

        currentCategoryId = categoryId;

        var topCategories = jQuery('.finder-categories-main li'),
            counter = topCategories.length;

        topCategories.each(function () {
            var cat = jQuery(this),
                key = 'category-' + categoryId,
                active = cat.hasClass(key) || jQuery('.top-category-' + cat.data('category') + ' .' + key).length > 0,
                subContainer = jQuery('#sub-category-' + cat.data('category'));

            if (active) {
                cat.addClass('active');
                subContainer.addClass('in');

                subContainer.find('li').each(function () {
                    var sub = jQuery(this),
                        subSubContainer = jQuery('#sub-sub-category-' + sub.data('category'));

                    subSubContainer.find('.finder-category-sub').removeClass('active');

                    // sub item active
                    if (sub.hasClass(key)) {
                        sub.addClass('active');
                        subSubContainer.addClass('in');
                        subSubContainer.find('.' + key).addClass('active');

                    }
                    // sub sub item active
                    else if (subSubContainer.find('.' + key).length > 0) {
                        sub.addClass('active');
                        subSubContainer.addClass('in');
                        subSubContainer.find('.' + key).addClass('active');
                    }
                    // none active
                    else {
                        sub.removeClass('active');
                        subSubContainer.removeClass('in');
                    }
                });

            } else {
                cat.removeClass('active');
                jQuery('.top-category-' + cat.data('category')).removeClass('in');
                subContainer.find('li').removeClass('active');
            }

            if (!--counter) {
                refreshCategoryInfo($scope);
            }
        });
    }

    $scope.$watch(function () {
            return $location.url();
        },
        function () {
            Track.page();

            var path = finderGetPath(),
                categoryId = categories[path],
                params = $location.search(),
                searchQuery = '',
                tagQuery = '';

            if (params && params.q) {
                searchQuery = params.q;
            }

            if (params && params.search) {
                tagQuery = params.search;
            }
            if (categoryId === undefined) {
                return
            }

            // scroll page up to show top products...
            var topPosition = jQuery('.finder-form-search').position().top,
                affixContainer = jQuery('.finder-categories-sub-container'),
                containerHeight = affixContainer.outerHeight(true);

            if (jQuery(document).scrollTop() > topPosition) {
                jQuery('html, body').animate({scrollTop: topPosition - containerHeight + 'px'}, 250);
            }

            categoryChangeHandler($scope, categoryId ? categoryId : finderConfig.homePageId);

            $scope.$emit('setUrlParams', {
                cat: searchQuery ? false : categoryId,
                tag: tagQuery,
                q: searchQuery
            });

            if (searchQuery) {
                $rootScope.$broadcast('sortForm.setSearchMode');
            } else {
                //$rootScope.$broadcast('sortForm.reset');
            }

            $rootScope.$broadcast('searchForm.' + (searchQuery ? 'setQuery' : 'clearQuery'), searchQuery);

            // ajax content
            if (searchQuery || tagQuery) {
                jQuery('#ajax-content').html('');
            } else {
                Util.getAjaxContent(path, function (data) {
                    Util.insertScripts(data, function () {
                        $('#ajax-content').html(data);
                        initRichContent();
                    });
                });
            }

            // funnel tracking
            var pathSegments = path.split('/');
            Track.event('funnel', {
                step: 'catalog',
                products: [{
                    category: pathSegments[3] ? pathSegments[3] : '',
                    subCategory: pathSegments[4] ? pathSegments[4] : ''
                }]
            });

        }
    );

}]);

finderApp.controller('browser', ['$scope', '$rootScope', 'productService', function ($scope, $rootScope, productService) {

    $scope.requestParams = {
        q: '',
        t: finderConfig.itemType,
        s: 'finder',
        l: Util.getLang(),
        cat: false,
        tag: '',
        sortBy: finderConfig.defaultSort,
        sortReverse: finderConfig.defaultSortReverse
    };

    $scope.$on('setUrlParams', function (event, newParams) {
        // add new params and/or unset undefined
        for (var param in newParams) {
            if (newParams[param] === undefined) {
                delete $scope.requestParams[param];
            }
            else {
                $scope.requestParams[param] = newParams[param];
            }
        }
        if (!$scope.requestParams.q) {
            $scope.requestParams.q = '';
            $rootScope.searchPage = false;
        }
        else {
            $rootScope.searchPage = true;
            $rootScope.$broadcast('sortForm.setSearchMode');
        }

        // check if it's homepage
        if ($scope.requestParams.t == finderConfig.itemType && (!$scope.requestParams.cat || $scope.requestParams.cat == finderConfig.homePageId) && !$scope.requestParams.q && !$scope.requestParams.tag) {
            $rootScope.homePage = true;
            $rootScope.onlyUpgrades = false;
            return;
        }
        $rootScope.homePage = false;

        // check if it's Upgrade page
        if ($scope.requestParams.t == finderConfig.itemType && ($scope.requestParams.cat == finderConfig.upgradesPageId) && !$scope.requestParams.q && !$scope.requestParams.tag) {
            $rootScope.onlyUpgrades = true;
        }
        else {
            $rootScope.onlyUpgrades = false;
        }

        // ask for products list

        productService.getProducts($scope.requestParams)
            .then(function(productsList) {
                $scope.$emit('productsList', productsList);
            });
    });

}]);

/*
 * Search form
 */
finderApp.controller('searchForm', ['$scope', '$rootScope', '$location', function ($scope, $rootScope, $location) {

    $scope.$on('searchForm.clearQuery', function (event) {
        $scope.keywords = '';
    });
    $scope.$on('searchForm.setQuery', function (event, value) {
        $scope.keywords = value;
    });
    $scope.performSearch = function (event) {
        event.stopPropagation();
        if ($scope.keywords) {
            $location.url(finderConfig.baseUrl + '?q=' + $scope.keywords + '&t=finder');
        }
        else {
            $location.url(finderConfig.baseUrl);
        }

        // hide keyboard on mobile
        if (Util.isMobile()) {
            document.activeElement.blur();
        }
    };

}]);

/*
 * Sort form
 */
finderApp.controller('sortForm', ['$scope', function ($scope) {
    var priceSorter = function (item) {
        return (item.price || {sort_price: 0}).sort_price;
    };
    var mappings = {
        priority: {expr: 'priority', reverse: false},
        title: {expr: 'title', reverse: false},
        latest: {expr: 'sort_date', reverse: true},
        price_asc: {expr: priceSorter, reverse: false},
        price_desc: {expr: priceSorter, reverse: true},
        searchRelevance: {expr: 'track_id', reverse: false}
    };
    $scope.$watch('sortByValue', function (newValue, oldValue) {
        $scope.$emit('sortForm.sortByChanged', mappings[newValue]);
    });
    $scope.$on('sortForm.reset', function (event) {
        $scope.sortByValue = 'priority';
    });
    $scope.$on('sortForm.setSearchMode', function (event) {
        $scope.sortByValue = 'searchRelevance';
    });
}]);

finderApp.filter('forceLazyLoading', function () {
    return function (items) {
        if (items.length) {
            jQuery(finderConfig.lazyLoadingSelector).responsiveLazyLoader();
        }
        return items;
    }
});

/*
 * Upgrades product list
 */
finderApp.controller('finderUpdatesList', ['$scope', '$q', 'productService', 'accountService', function ($scope, $q, productService, accountService) {

    $scope.requestParams = {
        q: '',
        t: finderConfig.itemType,
        s: 'finder',
        l: Util.getLang(),
        sortBy: finderConfig.defaultSort,
        sortReverse: finderConfig.defaultSortReverse,
        upgrade_ids: ''
    };

    accountService.getRegistrations()
        .then(function(ids) {
            if (!ids.length) {
                return $q.reject();
            }

            $scope.requestParams.upgrade_ids = ids.join(',');

            return productService.getProducts($scope.requestParams);
        })
        .then(function(productsList) {
            $scope.$emit('sortForm.sortByChanged', {expr: 'priority', reverse: false});
            $scope.$emit('productsList', productsList);
            accountService.setShownUpdates(productsList);
        }).catch(function() {
            $scope.$emit('productsList', []);
        });
}]);

/*
 * Static products list
 */
finderApp.controller('finderStaticList', ['$scope', 'productService', function ($scope, productService) {

    $scope.setProducts = function (productsList, itemType) {

        $scope.requestParams = {
            q: '',
            t: itemType,
            s: 'featured',
            l: Util.getLang(),
            cat: false,
            filter: '',
            sortBy: finderConfig.defaultSort,
            sortReverse: finderConfig.defaultSortReverse
        };

        var orderedProductIds = $.map(
            productsList.split(','),
            function (productId) {
                return parseInt(productId);
            }
        );
        $scope.requestParams.filter = JSON.stringify({ids: productsList});

        productService.getProducts($scope.requestParams)
            .then(function(productsList) {
                // keep the order of products in the list
                for (var i = 0, len = productsList.length; i < len; i++) {
                    productsList[i].staticOrder = orderedProductIds.indexOf(productsList[i].origin_id || productsList[i].id);
                }
                $scope.$emit('sortForm.sortByChanged', {expr: 'staticOrder', reverse: false});
                $scope.$emit('productsList', productsList);
            });
    }
}]);

/*
 * Category products list
 */
finderApp.controller('finderCategoryList', ['$scope', 'productService', function ($scope, productService) {

    $scope.setCategory = function (categoryId, itemType, limit) {

        $scope.requestParams = {
            q: '',
            t: itemType,
            s: 'finder',
            l: Util.getLang(),
            cat: categoryId,
            li: limit || 3,
            sortBy: finderConfig.defaultSort,
            sortReverse: finderConfig.defaultSortReverse
        };

        productService.getProducts($scope.requestParams)
            .then(function(productsList) {
                $scope.$emit('sortForm.sortByChanged', {expr: 'priority', reverse: false});
                $scope.$emit('productsList', productsList);
            });
    }
}]);


// application controller
finderApp.controller('ProductController', ['$scope', '$rootScope', '$location', '$timeout', 'accountService', function ($scope, $rootScope, $location, $timeout, accountService) {

    $rootScope.sortBy = finderConfig.defaultSort;
    $rootScope.sortReverse = finderConfig.defaultSortReverse;
    $scope.finderItems = [];
    $scope.initialized = false;
    $scope.target = '';

    accountService.getUserData().then(function() {
        $scope.loggedIn = Account.isValidSession();
    });
    
    $scope.player = {
        state: null,
        id: null
    };

    // watch sorting change
    $scope.$on('sortForm.sortByChanged', function (event, sortTerms) {
        $rootScope.sortBy = sortTerms.expr;
        $rootScope.sortReverse = sortTerms.reverse;
    });

    // watch product list change
    $scope.$on('productsList', function (event, productsList) {
        $scope.initialized = true;
        $scope.finderItems = productsList;
    });

    $scope.$on('ngRepeatFinished', function (ngRepeatFinishedEvent) {
        jQuery(finderConfig.lazyLoadingSelector).responsiveLazyLoader();
    });

    $scope.lazyLoad = function () {
        jQuery(finderConfig.lazyLoadingSelector).responsiveLazyLoader();
    };

    $scope.loadMedia = function (id, src, type, sku) {
        if (type == 'audio') {
            if (sku == $scope.player.id && ['paused', 'playing'].indexOf($scope.player.state) > -1) {
                nisp.pauseOrPlay();
                return false;
            } else {

                nisp.statechange(function(state) {
                    $timeout(function() {
                        $scope.player.state = state;
                    });
                });

                $scope.player.id = sku;
            }
        }

        Media.refresh(id, src, type);
        return false;
    };

}]);

jQuery(function () {
    // force scrolling to document top on CTA button click
    $(document).on('click', '.finder-overview-box .btn', function () {
        jQuery('html, body').stop(true, true).scrollTop(0);
    });

});


